<template>
  <div v-if="customgeolevelselected !== null">
    <el-menu id="geoLevelSelector" mode="horizontal" :unique-opened="true" menu-trigger="click" @open="menuOpened = true">
      <el-submenu index="1" class="fake-selector">
        <template slot="title">
          <span>{{ $t(customgeolevelselected.literalLevelname) }}: {{ customgeolevelselected.name }}</span>
        </template>
        <el-menu-item v-for="item in geolevels" :key="item.id" :label="$t(item.literalLevelname) + ': ' + item.name" :value="item.id" class="geoselector_option" @click="selectGeoItem(item.id)">
          <span style="float: left">{{ item.name }}</span>
          <span style="float: right; color: #8492a6; font-size: 11px; margin-left: 35px">{{ $t(item.literalLevelname) }}</span>
        </el-menu-item>
      </el-submenu>
    </el-menu>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'GenericLevelSelector',
  components: {},
  props: {
    tituloVisible: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      customgeolevelselected: null
    }
  },
  computed: {
    ...mapState('location', {
      geolevels: (state) => state.geolevels
      // geolevelselected: (state) => state.geolevelselected
    })
  },
  watch: {
    geolevels: function() {
      if (this.$route.query.latitude && this.$route.query.longitude && this.$route.query.level) {
        this.selectGeoItem(this.geolevels.filter((item) => item.level === parseInt(this.$route.query.level))[0].id)
      } else {
        this.selectGeoItem(this.geolevels.filter((item) => item.level === 3)[0].id)
      }
    }
  },
  methods: {
    selectGeoItem(id) {
      this.customgeolevelselected = this.geolevels.filter((item) => item.id === id)[0]
      this.$emit('genericlevelchange', this.customgeolevelselected)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
